import { useCallback } from 'react';
import { generateEmptyContentItem } from '../config/CodelessInitialValues/codelessInitialValues';
import { useConversions } from './useConversions';

export const useHandleCreateConversion = () => {
    const { setConversions } = useConversions();

    return useCallback(() => {
        const newEmptyConversion = generateEmptyContentItem();
        setConversions(prev => {
            const updatedConversions = [...prev];
            updatedConversions.push(newEmptyConversion);

            return updatedConversions;
        });
        return newEmptyConversion.id;
    }, [setConversions]);
};
